export class HostingDomainZoneData {
  id: number;
  name: string;
  nameservers: any;
  zoneId: string;
}

